<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pricing.partner.details.doctorsFee.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row mb-3">
      <div class="col-12 col-md-4">
        <label class="label mb-1" for="doctorsFeeValidFrom">
          {{ 'pricing.partner.details.bulkEdit.validFrom' | translate }}
        </label>
        <input
          #validFromDatepicker="ngbDatepicker"
          ngbDatepicker
          id="doctorsFeeValidFrom"
          class="form-control"
          container="body"
          data-cy="doctors-fee-valid-from"
          [formField]="feeForm.validFrom"
          [readonly]="true"
          [minDate]="momentToNgbDate(minDate)"
          [maxDate]="momentToNgbDate(maxDate)"
          [startDate]="momentToNgbDate(startDate)"
          [placeholder]="'serviceData.form.placeholders.dateFormat' | translate"
          (click)="validFromDatepicker.toggle()"
        />
      </div>
      <div class="col-10 col-md-7">
        <label class="label mb-1">
          {{ 'pricing.partner.details.bulkEdit.copyFromPartner' | translate }}
        </label>
        <app-partner-typeahead
          [control]="copyPartnerControl"
          [placeholder]="
            'pricing.partner.details.bulkEdit.copyFromPartnerPlaceholder'
              | translate
          "
          (partnerSelected)="onPartnerSelected($event)"
        ></app-partner-typeahead>
      </div>
      <div class="col-2 col-md-1 d-flex align-items-end">
        <button
          type="button"
          class="icon-btn icon-btn-lg"
          triggers="hover"
          placement="top bottom"
          container="body"
          data-cy="copy-country-prices-btn"
          [ngbTooltip]="
            'pricing.partner.details.bulkEdit.copyFromCountry'
              | translate: { country: pricingPartner()?.country }
          "
          [disabled]="copyingFromCountry() || !rows().length"
          (click)="copyFromCountry($event)"
        >
          <i class="fa-light fa-cube"></i>
        </button>
      </div>
    </div>
    @if (currencyMissing()) {
      <div class="notes mb-3">
        {{ 'pricing.partner.details.noCurrencyWarning' | translate }}
      </div>
    }
    @if (!rows().length) {
      <div class="notes">
        {{ 'pricing.partner.details.bulkEdit.empty' | translate }}
      </div>
    } @else {
      <div class="table-responsive">
        <table class="table table-sm align-middle doctors-fee-table">
          <thead>
            <tr>
              <th scope="col" rowspan="2" class="align-bottom">
                {{ 'pricing.partner.details.bulkEdit.bundle' | translate }}
              </th>
              <th scope="col" rowspan="2" class="align-bottom text-end">
                {{
                  'pricing.partner.details.bulkEdit.currentPrice' | translate
                }}
              </th>
              <th scope="col" colspan="5" class="text-center">
                {{ 'pricing.partner.details.doctorsFee.newWholesalePrice' | translate }}
              </th>
            </tr>
            <tr>
              <th scope="col" class="text-end">
                {{ 'pricing.partner.details.doctorsFee.eup' | translate }}
              </th>
              <th scope="col" class="text-center operator"></th>
              <th scope="col" class="text-center">
                {{ 'pricing.partner.details.doctorsFee.fee' | translate }}
              </th>
              <th scope="col" class="text-center operator"></th>
              <th scope="col" class="text-end">
                {{ 'pricing.partner.details.doctorsFee.newWsp' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.bundleId; let i = $index) {
              <tr>
                <td>{{ row.name }}</td>
                <td class="text-end">
                  @if (row.currentWsp !== null) {
                    {{ row.currentWsp | number: '1.2-2' }}
                  } @else {
                    <span class="text-danger">{{
                      'pricing.partner.details.missingPrice' | translate
                    }}</span>
                  }
                </td>
                <td class="text-end">
                  @if (row.eup !== null) {
                    {{ row.eup | number: '1.2-2' }}
                  } @else {
                    <span class="text-danger">{{
                      'pricing.partner.details.doctorsFee.missingEup'
                        | translate
                    }}</span>
                  }
                </td>
                <td class="text-center operator">−</td>
                <td class="fee-cell">
                  <input
                    type="number"
                    step="0.01"
                    class="form-control form-control-sm text-end"
                    [formField]="feeForm.fees[i].fee"
                    [placeholder]="
                      'pricing.partner.details.doctorsFee.feePlaceholder'
                        | translate
                    "
                    [attr.data-cy]="'doctors-fee-input-' + row.bundleId"
                  />
                </td>
                <td class="text-center operator">=</td>
                <td class="text-end fw-bold">
                  @if (newWsp(row, i) !== null) {
                    {{ newWsp(row, i) | number: '1.2-2' }}
                  } @else if (row.eup === null) {
                    <span class="text-danger fw-normal">{{
                      'pricing.partner.details.doctorsFee.cannotCalculate'
                        | translate
                    }}</span>
                  } @else {
                    -
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-clear"
      (click)="modalRef.close()"
      data-cy="close-btn"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="submitDisabled()"
      (click)="save()"
      data-cy="save-btn"
    >
      {{ 'pricing.partner.details.bulkEdit.save' | translate }}
    </button>
  </div>
</div>
